// Import Flickity module
import {
  initFlickity,
  createFlickity,
  whenFlickityReady,
  setupArrowNavigation,
  setupClickHandlers,
} from "../modules/flickity.js";

// Initialize feeds carousel
const initFeeds = async () => {
  const feeds = await createFlickity(".feeds", {
    groupCells: true,
    autoPlay: 10000,
    lazyLoad: true,
  });

  if (!feeds) return;

  // Setup click handlers
  setupClickHandlers(feeds, (cellElement, cellIndex) => {
    // Handle feed click if needed
  });

  // Setup arrow navigation
  setupArrowNavigation(feeds, ".cta-feed");
};

// Initialize when DOM is ready and Flickity is available
$(document).ready(() => {
  whenFlickityReady(initFeeds);
});
